import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useSelector } from 'react-redux'

import * as sessionUserSelector from 'selectors/sessionUser'
import { userTimeZoneFormat } from 'utils/time'

import {
  REQUEST_METHOD_BADGE_COLOR_MAP,
  RESPONSE_STATUS_COLORS_MAP,
} from 'constants/colorMaps'

import Badge from 'components/Shared/Badge/Index'
import Tooltip from 'components/Shared/Tooltip/Index'
import TableRow from 'components/Shared/TableNew/TableRow'
import TableCell from 'components/Shared/TableNew/TableCell'

const StyledTableCell = styled(TableCell)`
  padding: 0 6px 0 12px;
`

const TableCellWithBadge = styled(TableCell)`
  padding: 0 6px;
`

const TableCellNoWrap = styled(TableCell)`
  white-space: nowrap;
`

const ResponseCodeBadge = styled(Badge)`
  padding: 0 5px;
`

const StyledUrl = styled.div`
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: normal;
`

const RequestsTableRow = ({ request, onClick, isSelected }) => {
  const userTimeZone = useSelector(sessionUserSelector.timezone)

  const requestMethod = (request.requestMethod || '').toUpperCase()
  const methodNameColor = REQUEST_METHOD_BADGE_COLOR_MAP[requestMethod]
  const responseTime = request.responseTime ? (request.responseTime.toFixed(3) + ' sec') : ''
  const tooltipIdUrl = 'table_tooltip_url_' + request.id
  const shortenUrl = request.url
  const responseCode = request.responseCode?.toString()
  const responseStatus = request.responseStatus
  const responseStatusColor = responseStatus ? RESPONSE_STATUS_COLORS_MAP[responseStatus] : null

  return (
    <TableRow
      onClick={() => { onClick(request) }}
      active={isSelected}
      color={responseStatusColor}
    >
      <StyledTableCell width='24px'>
        <Badge color={methodNameColor} margin='0'>
          {requestMethod}
        </Badge>
      </StyledTableCell>

      <TableCell>
        <StyledUrl
          data-tooltip-content={request.url}
          data-tooltip-id={tooltipIdUrl}
        >
          {shortenUrl}
        </StyledUrl>
        <Tooltip id={tooltipIdUrl} maxWidth='600px' />
      </TableCell>

      <TableCellWithBadge width='24px'>
        {responseCode && (
          <ResponseCodeBadge color={responseStatusColor} margin='0'>
            {responseCode}
          </ResponseCodeBadge>
        )}
      </TableCellWithBadge>

      <TableCellNoWrap>{userTimeZoneFormat(userTimeZone, request.startedAt)}</TableCellNoWrap>
      <TableCellNoWrap>{responseTime}</TableCellNoWrap>
    </TableRow>
  )
}

RequestsTableRow.propTypes = {
  request: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
}

export default RequestsTableRow
